function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "facebook-brands",
  d: "M24,33.323V54.671a1.323,1.323,0,0,1-1.323,1.323H16.559V46.705h3.118l.466-3.621H16.554V40.77c0-1.05.289-1.763,1.795-1.763h1.918V35.766a25.784,25.784,0,0,0-2.8-.145c-2.764,0-4.661,1.688-4.661,4.789v2.673H9.68v3.621h3.129V56H1.323A1.326,1.326,0,0,1,0,54.677V33.323A1.326,1.326,0,0,1,1.323,32H22.671A1.327,1.327,0,0,1,24,33.323Z",
  transform: "translate(0 -32)",
  fill: "#fff"
});

var SvgFacebookBrands = function SvgFacebookBrands(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookBrands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-brands.615eadac.svg";
export { ForwardRef as ReactComponent };